import {domainSeparationProperties} from '@servicenow/ui-effect-helpers';

const SUPPORTED_KINDS = ['OperationDefinition'];

function canAddDomainSeparationDirective(definition) {
	return (
		(SUPPORTED_KINDS.includes(definition.kind) && definition.operation === 'query') ||
		definition.operation === 'mutation'
	);
}

/**
 *
 * @param document
 * @param domainContext
 * @returns {*}
 */
export default function addDomainContextToGraphQLDocument(document, domainContext) {
	if (domainContext) {
		const domainDirective = createDomainDirective(
			domainContext[domainSeparationProperties.NOW_DS_RECORD_TABLE],
			domainContext[domainSeparationProperties.NOW_DS_RECORD_ID],
			domainContext[domainSeparationProperties.NOW_DS_DOMAIN_ID],
			domainContext[domainSeparationProperties.NOW_DS_DOMAIN_SCOPE]
		);
		if (domainDirective) {
			return {
				...document,
				definitions: document.definitions.map(def => ({
					...def,
					directives: [
						...def.directives,
						...insertIf(canAddDomainSeparationDirective(def), domainDirective)
					]
				}))
			};
		}
	}
	return document;
}

export function createDomainDirective(recordTable, recordId, domainId, domainScope) {
	const recordArgument = createRecordArgument(recordTable, recordId);
	const domainArgument = createDomainArgument(domainId, domainScope);
	const args = [
		...insertIf(recordArgument !== undefined, recordArgument),
		...insertIf(domainArgument !== undefined, domainArgument)
	];

	if (!args.length) return undefined;

	return {
		kind: 'Directive',
		name: {kind: 'Name', value: 'domain'},
		arguments: args
	};
}

export function createRecordArgument(table, id) {
	if (!isValidRecordArgument(table, id)) return undefined;

	return {
		kind: 'Argument',
		name: {kind: 'Name', value: 'record'},
		value: {
			kind: 'ObjectValue',
			fields: [
				{
					kind: 'ObjectField',
					name: {kind: 'Name', value: 'tableName'},
					value: {kind: 'StringValue', value: table}
				},
				{
					kind: 'ObjectField',
					name: {kind: 'Name', value: 'id'},
					value: {kind: 'StringValue', value: id}
				}
			]
		}
	};
}

export function createDomainArgument(id, scope) {
	if (!isValidDomainArgument(id, scope)) return undefined;

	return {
		kind: 'Argument',
		name: {kind: 'Name', value: 'domain'},
		value: {
			kind: 'ObjectValue',
			fields: [
				...insertIf(id !== undefined, {
					kind: 'ObjectField',
					name: {kind: 'Name', value: 'id'},
					value: {kind: 'StringValue', value: id}
				}),
				...insertIf(scope !== undefined, {
					kind: 'ObjectField',
					name: {kind: 'Name', value: 'scope'},
					value: {kind: 'EnumValue', value: scope}
				})
			]
		}
	};
}

export function isValidRecordArgument(table, id) {
	return table !== undefined && id !== undefined;
}

export function isValidDomainArgument(id, scope) {
	return id !== undefined || scope !== undefined;
}

export function insertIf(condition, value) {
	return condition ? [value] : [];
}
